import React, { FC } from 'react'
import cx from 'classnames'
import { DivProps } from '@commonTypes'
import css from './clearableSelectWrapper.module.scss'

const ClearableSelectWrapper: FC<React.PropsWithChildren<DivProps>> = ({
  className = '',
  ...props
}) => {
  return <div className={cx(css.clearable_select_wrapper, className)} {...props} />
}

export default ClearableSelectWrapper
